<template>
  <v-menu
    v-model="datetimeOpen"
    :max-width="520"
    :min-width="520"
    :close-on-content-click="false"
    content-class="UXDatapicker"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdateInput" v-on="on" :class="{'disabled': disabled}">
        <span class="inpTxt" v-if="picker !== ' '">{{ picker }}</span>
        <span class="inpTxt" v-else>0000-00-00 ~ 0000-00-00</span>
        <i class="UXicon-calendar"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong v-if="calendarData.dateRange">{{ isDateOut(calendarData.dateRange.start) }} ~ {{ calendarData.dateRange.end ? isDateOut(calendarData.dateRange.end) : '日付選択' }}</strong>
          <strong v-else>日付選択</strong>
        </p>
        <div class="endBtn" v-if="picker && (calendarData.dateRange && calendarData.dateRange.end)">
          <v-btn dark color="#ff8c8c" @click="setDataTime">
            完了
          </v-btn>
        </div>
      </div>
      <div class="con">
        <FunctionalCalendar
          ref="funCalendar"
          v-model="calendarData"
          :configs="calendarConfigs"
        ></FunctionalCalendar>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { FunctionalCalendar } from 'vue-functional-calendar'
import moment from 'moment'

export default {
  name: 'datePicker',
  components: {
    FunctionalCalendar
  },
  data () {
    return {
      calendarData: {},
      calendarConfigs: {
        sundayStart: true,
        isDateRange: true,
        isMultiple: true,
        calendarsCount: 2,
        hiddenElements: ['leftAndRightDays'],
        dateFormat: 'yyyy-mm-dd',
        dayNames: ['月', '火', '水', '木', '金', '土', '日'],
        monthNames: ['.01', '.02', '.03', '.04', '.05', '.06', '.07', '.08', '.09', '.10', '.11', '.12'],
        disabledDates: this.disabledDates,
        markedDateRange: {
          start: '',
          end: ''
        },
        limits: this.limits,
        maxSelDays: this.maxSelDays
      },
      datetimeOpen: false,
      picker: ''
    }
  },
  props: ['startDate', 'endDate', 'disabledDates', 'disabled', 'limits', 'maxSelDays'],
  watch: {
    startDate () {
      this.changeDate()
    },
    endDate () {
      this.changeDate()
    },
    datetimeOpen () {
      let fromDate = this.startDate ? this.startDate : moment().format('YYYY-MM-DD')
      let toDate = this.endDate ? this.endDate : moment().format('YYYY-MM-DD')

      setTimeout(() => {
        this.calendarData.dateRange.start = this.isDateIn(fromDate)
        this.calendarData.dateRange.end = this.isDateIn(toDate)
      })
      this.$refs.funCalendar.ChooseDate(this.isDateIn(fromDate))
    }
  },
  created () {
    if (!this.startDate || !this.endDate) {
      this.picker = ' '
    } else {
      this.picker = this.isDateOut(this.startDate) + ' ~ ' + this.isDateOut(this.endDate)
    }
  },
  methods: {
    isDateIn (val) {
      if (val) {
        let date = val.split('-').map(k => k.toString()[0] === '0' ? k.replace('0', '') : k)
        return date[0] + '-' + date[1] + '-' + date[2]
      }
    },
    isDateOut (val) {
      if (val) {
        let date = val.split('-').map(k => k.toString().length === 1 ? '0' + k : k)
        if (date[1] === '00') date[1] = '01'
        return date[0] + '-' + date[1] + '-' + date[2]
      }
    },
    changeDate () {
      this.$refs.funCalendar.dateRangeSelectedStartDate = this.startDate
      this.$refs.funCalendar.dateRangeSelectedEndDate = this.endDate
      if (!this.startDate && !this.endDate) {
        this.picker = ' '
      } else {
        this.picker = this.startDate + ' ~ ' + this.endDate
      }
    },
    setDataTime () {
      try {
        if (this.calendarData.dateRange) {
          let datePicker = {
            start: this.isDateOut(this.calendarData.dateRange.start),
            end: this.isDateOut(this.calendarData.dateRange.end)
          }
          this.$emit('child', datePicker)
          this.picker = datePicker.start + ' ~ ' + datePicker.end
        }
        this.datetimeOpen = false
      } catch (e) {
        console.log(e)
      }
    },
    getDay (date) {
      const daysOfWeek = ['月', '火', '水', '木', '金', '土', '日']
      return daysOfWeek[new Date(date).getDay(date)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DatePicker.vue